const Loader = {
  state: {
    loading: 0
  },
  getters: {
    isLoading: (state) => state.loading > 0
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    }
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading += loading ? 1 : -1
    }
  }
}

export default Loader



// WEBPACK FOOTER //
// ./src/store/modules/loader.js